import { Idp, IdpType } from 'module/api/account/types';
import { useTranslate } from 'module/hooks/use-translation';
import { OktaAuth } from '@okta/okta-auth-js';
import { Button } from '@rocketlane/ui';
import { ReactComponent as Google } from './google.svg';

type BaseProps = { idp: Idp; oktaAuth: OktaAuth };
type CognitoSamlProps = BaseProps & {
  isCognitoEnabled: true;
  googleSSOHandler: () => void;
  samlFlowHandler: () => Promise<void>;
};
type OktaSamlProps = BaseProps & { isCognitoEnabled: false };
type Props = OktaSamlProps | CognitoSamlProps;

export const SsoSamlButton = (props: Props) => {
  const translate = useTranslate();
  const { idp, oktaAuth } = props;

  return (
    <Button
      key={idp.idpId}
      rightIcon={idp.idpType === IdpType.Google && <Google />}
      onClick={() => {
        if (props.isCognitoEnabled) {
          if (idp.idpType === IdpType.Google) {
            props.googleSSOHandler();
          } else {
            props.samlFlowHandler();
          }

          return;
        }
        oktaAuth.signInWithRedirect({ idp: idp.idpId });
      }}
    >
      {idp.idpType === IdpType.Google
        ? translate('google.sign-in')
        : translate('sign_in.sso')}
    </Button>
  );
};
